import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row, Table } from 'react-bootstrap'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import { Checkbox } from 'antd'
import StapMainLayout from './step-main'
import { EMP_CHECK_LIST_DETAIL_ST_2 } from '../../../../router/routes'
import { BsChevronDoubleRight } from 'react-icons/bs'
import ImgCheckbox from '../../../../images/checkbox.svg'
import styled from 'styled-components'
import TextDecodeHTML from '../../../text-html-br'
import {
  getChecklistNewFloorDetailAPI,
  getChecklistNewStepDetailAPI,
  putChecklistNewOneAPI
} from '../../../../services/checklist'
import Error_500 from '../../../error/error-500'
import moment from 'moment'
import SwalCustom from '../../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../../Constants'
import Error_false from '../../../error/error-false'
import SwalCustomSuccess from '../../../../alert/swal-success'

export default function StapPage1(step) {
  let [searchParams] = useSearchParams()
  const org = searchParams.get('org')
  const code = searchParams.get('code')
  const clnNo = searchParams.get('id')
  const status = searchParams.get('status')

  const [stepId, setStepId] = useState([])
  const [hasEdit, setHasEdit] = useState([])
  const [createDate, setCreateDate] = useState([])
  const [rightsId, setRightsId] = useState(0) //สิทธิการเข้า-ออก ประตูสำนักงาน
  const [building1, setBuilding1] = useState([]) //พื้นที่ปฏิบัติงาน*
  const [building2, setBuilding2] = useState([]) //พื้นที่ปฏิบัติงาน*
  const [building3, setBuilding3] = useState([]) //ลิฟต์-ตึกหน้า
  const [building4, setBuilding4] = useState([]) //ลิฟต์-ตึกหลัง
  const [dataStep, setDataStep] = useState([])
  const [approve, setApprove] = useState()
  const [isSubmit, setIsSubmit] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [dataGusto, setDataGusto] = useState({ groups: [] })
  const [dataGustoDetail, setDataGustoDetail] = useState([])
  const [selectGusto, setSelectGusto] = useState({ id: 0, input: null })
  const ID_Door = 1
  const ID_Gusto = 5

  useEffect(() => {
    getStep()
    getBuilding()
    return () => {}
  }, [])
  const getStep = async (stepId = 1) => {
    try {
      setIsLoading(true)
      const resp = await getChecklistNewStepDetailAPI({
        stepId,
        clnNo
      })
      setIsLoading(false)

      if (!resp) return
      if (resp.status) {
        setCreateDate(resp.result.insert_date)
        setHasEdit(resp.result.has_edit)
        setStepId(resp.result.step_id)
        setApprove(resp.result.approve)
        setDataStep(resp.result.result)

        const _gusto = resp.result.result.find(
          (item) => item.equip_pd_group_id === ID_Gusto
        )
        if (_gusto) {
          const _selGusto = _gusto.groups.find((item) => item.is_check)
          setSelectGusto({
            id: _selGusto?.id ?? 0,
            input: _selGusto?.detail ?? null
          })
          setDataGusto(_gusto ?? { groups: [] })
          setDataGustoDetail(_gusto.groups)
        }

        const _door = resp.result.result.find(
          (item) => item.equip_pd_group_id === ID_Door
        )
        const f1 = _door?.groups?.find((d) => d.is_check === 1)
        setRightsId(f1?.id ?? 0)
      } else {
        setDataStep([])
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const getBuilding = async () => {
    try {
      const resp = await getChecklistNewFloorDetailAPI({
        clnNo
      })
      if (!resp) return
      if (resp.status) {
        setBuilding1(resp.result.build1)
        setBuilding2(resp.result.build2)
        setBuilding3(resp.result.build3)
        setBuilding4(resp.result.build4)
      } else {
        setBuilding1([])
        setBuilding2([])
        setBuilding3([])
        setBuilding4([])
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const nevigate = useNavigate()
  const fnNext = () => {
    nevigate(
      {
        pathname: EMP_CHECK_LIST_DETAIL_ST_2,
        search: `?${createSearchParams({
          code,
          org,
          id: clnNo,
          status: status
        })}`
      },
      { replace: true }
    )
  }

  // พื้นที่ปฏิบัติงานตึกหน้า
  const fnInputBuilding1 = (event, id) => {
    const { value, checked } = event.target

    if (checked) {
      setBuilding1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setBuilding1((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }
  // พื้นที่ปฏิบัติงานตึกหลัง
  const fnInputBuilding2 = (event, id) => {
    const { value, checked } = event.target
    if (checked) {
      setBuilding2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setBuilding2((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }
  // ลิฟต์ตึกหน้า
  const fnInputBuilding3 = (event, id) => {
    const { value, checked } = event.target
    if (checked) {
      setBuilding3((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setBuilding3((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }
  // ลิฟต์ตึกหลัง
  const fnInputBuilding4 = (event, id) => {
    const { value, checked } = event.target
    if (checked) {
      setBuilding4((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 1
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    } else {
      setBuilding4((prev) => {
        const newData = prev.filter((item) => item.id === id)
        return [
          ...[
            {
              ...newData[0],
              is_check: 0
            }
          ],
          ...prev.filter((item) => item.id !== id)
        ]
      })
    }
  }

  const onSubmit = async (data) => {
    try {
      setIsSubmit(true)
      setIsLoading(true)
      const f1 = building1.filter((d) => d.is_check === 1)
      const f2 = building2.filter((d) => d.is_check === 1)
      const f3 = building3.filter((d) => d.is_check === 1)
      const f4 = building4.filter((d) => d.is_check === 1)

      // สิทธิ์การเข้า-ออก ประตูสำนักงาน
      const e1 = {
        equipId: ID_Door,
        id: rightsId,
        detail: ''
      }

      // สิทธ์โรงอาหาร (Gusto)
      const e2 = {
        equipId: ID_Gusto,
        id: selectGusto.id
        // detail: selectGusto.input ?? ''
      }
      const floors = [...f1, ...f2, ...f3, ...f4].map((d) => d.id)
      const equips = [e1, selectGusto.id ? e2 : {}]
      const param = { clnNo }
      const body = {
        floors,
        equips
      }
      // console.log('body', body)

      if (
        [...f1, ...f2, ...f3, ...f4].length > 0 &&
        rightsId > 0 &&
        selectGusto.id
      ) {
        const resp = await putChecklistNewOneAPI(param, body)
        setIsSubmit(false)
        setIsLoading(false)
        if (!resp) return
        if (resp.status) {
          SwalCustomSuccess().then(() => {
            getStep()
          })
        } else {
          Error_false(resp)
        }
      } else {
        SwalCustom({
          title: 'ตรวจสอบข้อมูล',
          text: 'โปรดกรอกข้อมูลให้ครบถ้วนก่อนกดยืนยัน',
          confirmButtonColor: '#f9af29',
          showConfirmButton: true
        })
        setIsSubmit(false)
        setIsLoading(false)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  // const onChangDataGusto = (id, todo) => {
  //   const new_list = fnUpdateArr(dataGusto.groups, id, todo)
  //   console.log('new_list', new_list)

  //   setDataGusto({
  //     ...dataGusto,
  //     groups: new_list
  //   })
  // }

  return (
    <Row>
      {isLoading && <div className="preloader"></div>}

      <Col
        xl={12}
        className="mt-3 mb-3"
        style={{ position: 'sticky', top: 0, zIndex: 1000 }}
      >
        <StapMainLayout current={0} />
      </Col>
      <div className="mt-2 mb-3">
        <span className="fw-bold me-2">เลขเอกสาร: </span>
        <span className="">{clnNo}</span>{' '}
        <span className="fw-light me-2">
          {createDate ? moment(createDate).format('DD/MM/YYYY HH:mm') : ''}{' '}
        </span>
      </div>
      <Col xl={12}>
        <div className="fw-bold  mb-3">
          {dataStep.length > 0 && dataStep[0].equip_pd_group}
        </div>
        <Checkbox.Group
          style={{
            width: '100%'
          }}
        >
          <Row>
            <CheckboxRadioCustom className="fw-light">
              {dataStep.length > 0 &&
                dataStep[0].groups &&
                dataStep[0].groups.length > 0 &&
                dataStep[0].groups.map((d, i) => (
                  <div className="form-check mb-3" key={`subDescription${i}`}>
                    <input
                      checked={rightsId === d.id ? true : false}
                      name={`group`}
                      type="radio"
                      id={`inline-radio-${i}`}
                      className="form-check-input"
                      onChange={(e) => {
                        setRightsId(d.id)
                      }}
                    />

                    <div>
                      <label
                        htmlFor={`inline-radio-${i}`}
                        className="form-check-label"
                      >
                        {d.equip_pd_name}
                      </label>

                      <TextDecodeHTML
                        text={d.equip_pd_detail}
                        style={{ marginLeft: '35px' }}
                        className="form-check-label mb-0"
                      />

                      {rightsId === d.id && (
                        <Table striped bordered style={{ width: 550 }}>
                          <thead>
                            <tr>
                              <th colSpan={2} className="text-center">
                                พื้นที่ปฏิบัติงาน*
                              </th>
                              <th colSpan={2} className="text-center">
                                ลิฟต์
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td className="text-center">ตึกหน้า</td>
                              <td className="text-center">ตึกหลัง</td>
                              <td className="text-center">ตึกหน้า</td>
                              <td className="text-center">ตึกหลัง</td>
                            </tr>
                            <tr>
                              <td style={{ maxWidth: '80px' }}>
                                <Checkbox.Group
                                  style={{
                                    width: '100%'
                                  }}
                                >
                                  <CheckboxRadioCustom className="fw-light">
                                    {building1.length > 0 &&
                                      building1
                                        .sort((a, b) => a.id - b.id)
                                        .map((d, i) => (
                                          <Form.Check
                                            key={`building1${d.id}${i}`}
                                            inline
                                            checked={
                                              d.is_check === 0 ? false : true
                                            }
                                            value={d.id}
                                            label={d.floor_name}
                                            name={`building1`}
                                            type="checkbox"
                                            onChange={(e) =>
                                              fnInputBuilding1(e, d.id)
                                            }
                                          />
                                        ))}
                                  </CheckboxRadioCustom>
                                </Checkbox.Group>
                              </td>
                              <td style={{ maxWidth: '80px' }}>
                                <Checkbox.Group
                                  style={{
                                    width: '100%'
                                  }}
                                >
                                  <CheckboxRadioCustom className="fw-light">
                                    {building2.length > 0 &&
                                      building2
                                        .sort((a, b) => a.id - b.id)
                                        .map((d, i) => (
                                          <Form.Check
                                            key={`building2${d.id}${i}`}
                                            inline
                                            checked={
                                              d.is_check === 0 ? false : true
                                            }
                                            label={d.floor_name}
                                            name={`building2`}
                                            type="checkbox"
                                            onChange={(e) =>
                                              fnInputBuilding2(e, d.id)
                                            }
                                          />
                                        ))}
                                  </CheckboxRadioCustom>
                                </Checkbox.Group>
                              </td>
                              <td style={{ maxWidth: '80px' }}>
                                <Checkbox.Group
                                  style={{
                                    width: '100%'
                                  }}
                                >
                                  <CheckboxCustom className="fw-light">
                                    {building3.length > 0 &&
                                      building3
                                        .sort((a, b) => a.id - b.id)
                                        .map((d, i) => (
                                          <Form.Check
                                            key={`elevator1${d.id}${i}`}
                                            inline
                                            checked={
                                              d.is_check === 0 ? false : true
                                            }
                                            label={d.floor_name}
                                            name={`elevator1`}
                                            type="checkbox"
                                            value={d.id}
                                            onChange={(e) =>
                                              fnInputBuilding3(e, d.id)
                                            }
                                          />
                                        ))}
                                  </CheckboxCustom>
                                </Checkbox.Group>
                              </td>
                              <td style={{ maxWidth: '80px' }}>
                                <Checkbox.Group
                                  style={{
                                    width: '100%'
                                  }}
                                >
                                  <CheckboxCustom className="fw-light">
                                    {building4.length > 0 &&
                                      building4
                                        .sort((a, b) => a.id - b.id)
                                        .map((d, i) => (
                                          <Form.Check
                                            key={`elevator2${d.id}${i}`}
                                            inline
                                            checked={
                                              d.is_check === 0 ? false : true
                                            }
                                            label={d.floor_name}
                                            name={`elevator2`}
                                            type="checkbox"
                                            value={d.id}
                                            onChange={(e) =>
                                              fnInputBuilding4(e, d.id)
                                            }
                                          />
                                        ))}
                                  </CheckboxCustom>
                                </Checkbox.Group>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </div>
                ))}
            </CheckboxRadioCustom>
          </Row>
        </Checkbox.Group>
      </Col>

      {dataGusto.groups.length > 0 && (
        <Col xl={12}>
          <div className="fw-bold  mb-3">{dataGusto?.equip_pd_group}</div>

          <Row className="g-2 mb-3">
            <Col xl={6}>
              <CheckboxRadioCustom>
                {dataGustoDetail.map((item) => (
                  <div
                    className="form-check mb-3"
                    key={item.id}
                    style={{ display: 'block', marginBottom: '8px' }}
                  >
                    <input
                      type="radio"
                      name="radioGroup"
                      value={item.id}
                      className="form-check-input"
                      checked={selectGusto.id === item.id}
                      onChange={() =>
                        setSelectGusto((prev) => ({ ...prev, id: item.id }))
                      }
                    />
                    <div>
                      <label className="form-check-label">
                        {item.equip_pd_name}
                      </label>
                    </div>

                    {/* <div className="mt-3">
                      {selectGusto.id === item.id && (
                        <Form.Control
                          as="textarea"
                          // className={`${d.status === 2 && !d.note && 'is-invalid'}`}
                          value={selectGusto.input}
                          onChange={(e) =>
                            setSelectGusto((prev) => ({
                              ...prev,
                              input: e.target.value
                            }))
                          }
                        />
                      )}
                    </div> */}
                  </div>
                ))}
              </CheckboxRadioCustom>
            </Col>
          </Row>
        </Col>
      )}

      {approve && (stepId === 0 || stepId === 1 || stepId === 5) && hasEdit ? (
        <Col xl={12} className="mt-5 text-center">
          <div className="text-secondary small mb-2">(สำหรับการแก้ไข)</div>
          <Button
            disabled={isSubmit}
            className="px-4 rounded-3"
            style={{ minWidth: 150 }}
            type="submit"
            onClick={onSubmit}
          >
            {isSubmit ? 'Submiting...' : 'Submit'}
          </Button>
        </Col>
      ) : (
        <></>
      )}

      {approve ? (
        <div className=" mt-5 font-small-2 d-flex justify-content-center">
          <div style={{ width: 300 }}>
            <div className="d-flex justify-content-center">
              {approve?.url === '' ? (
                <span className="text-secondary ">ไม่พบลายเซ็น</span>
              ) : (
                <Image width={250} fluid src={approve?.url} />
              )}
            </div>
            <div className="d-flex justify-content-center">
              ลงชื่อ
              <div
                style={{
                  borderBottom: '1px dashed rgb(135, 135, 135)',
                  width: 200
                }}
              ></div>{' '}
              ผู้ดำเนินการ
            </div>
            <div className="d-flex justify-content-center mt-3">
              ({approve?.title_th} {approve?.name_th} {approve?.surname_th})
            </div>
            <div className="d-flex justify-content-center fw-light mt-1">
              {approve?.position_th}
            </div>
            <div className="d-flex justify-content-center fw-light">
              {moment(approve.confirm_date1).format('DD/MM/YYYY')}
            </div>
          </div>
        </div>
      ) : (
        <Col xl={12} className="mt-5 text-center">
          <Button
            disabled={isSubmit}
            className="px-4 rounded-3"
            style={{ minWidth: 150 }}
            type="submit"
            onClick={onSubmit}
          >
            {isSubmit ? 'Submiting...' : 'Submit'}
          </Button>
        </Col>
      )}

      <div
        className="d-flex justify-content-end mt-5 mb-3 pe-4"
        style={{ position: 'sticky', bottom: 0, zIndex: 1000 }}
      >
        {approve && (
          <span className="p-3  border-0 small pointer-event " onClick={fnNext}>
            Next
            <BsChevronDoubleRight className="ms-2 " />
          </span>
        )}
      </div>
    </Row>
  )
}
const CheckboxRadioCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 1rem;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
  }
`

const CheckboxCustom = styled.div`
  .form-check-inline {
    display: inline-block;
    margin-right: 3px;
  }

  .form-check-input[type='radio'] {
    margin-top: auto !important;
    margin-bottom: auto !important;
    border-radius: 4px !important;
    background-image: url(${ImgCheckbox}) !important;
  }
  .form-check-input:checked {
    background-color: 'var(--comp-badge-color-background-primary)' !important;
  }
  .form-check-input {
    width: 1.5em;
    height: 1.5em;
    border: 1px solid 'var(--comp-badge-color-background-primary)';
  }
  label {
    margin: 0em 0em 0em 1em;
  }
  .form-check .form-check-input {
    float: left;
    margin-left: 0em;
    margin-top: 0em;
  }
`
